function getFontCss(theme) {
	let fontDefinitions = [
		"body1",
		"body2",
		"button",
		"caption",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"overline",
		"subtitle1",
		"subtitle2",
		"titleBar",
		"inherit",
	];
	let fontCss = "";
	for (let i = 0; i < fontDefinitions.length; i++) {
		let fontDefinition = fontDefinitions[i];
		if (theme.typography[fontDefinition]) {
			fontCss += `
		    .variant-${fontDefinition} { `;

			for (const [key, val] of Object.entries(theme.typography[fontDefinition])) {
				const cssPropName = key
					.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2")
					.toLowerCase();
				fontCss += `${cssPropName}: ${val}; `;
			}
			fontCss += `}`;
		}
	}
	return fontCss;
}

export default getFontCss;
